import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'react-apollo';
import {FooterQuery} from './FooterQuery';
import {SiteFooter} from '@homeaway/react-site-footer';

export class Footer extends Component {
    static propTypes = {
        systemData: PropTypes.shape({}),
    };

    static defaultProps = {
        systemData: {},
    };

    render() {
        const {data, systemData} = this.props;

        return (
            <SiteFooter
                data={data.footer}
                site={systemData.site?.name}
                isMobile={systemData.isMobile}
                brand={systemData.site?.humanReadableBrandName}
                deviceOSType={systemData.deviceOSType}
            />
        );
    }
}

export default graphql(FooterQuery)(Footer);
